import React, {useState, useEffect} from "react";
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import FirstAidUpdateForm from "./FirstAidUpdateForm";
import { SIREN_CONFIG } from 'config.js';
import moment from 'moment';
import {useSelector} from 'react-redux';
import { useIntl } from "react-intl";


const FirstAidUpdate = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  const {formatMessage} = useIntl();
  
  const [emergencyInfo, setEmergencyInfo] = useState(null);
  const facility_id = useSelector((store) => store.user.facility_id);


  const loadData = (eventId) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/emergency/queryEmergencyInfo?facility_id=${facility_id}&eid=${eventId}`;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {

      if (snapshot.resultData[0] != null){
        const newData = snapshot.resultData[0];
        var emergency = {
          deviceId: newData.deviceId,
          eventId: newData.eventId,
          first_eventTime: newData.first_eventTime ,
          lastStatus: newData.lastStatus,
          action: newData.action,
          actionTimeStamp: newData.actionTimestamp && moment(newData.actionTimestamp).format('YYYY-MM-DD HH:mm') || '',
          actionUser: newData.action_user,
          isSentPush: newData.isSentPush >= 1 ? formatMessage({id:'isSent'}): formatMessage({id:'isNotSent'}),
          roomName: newData.roomName,
          installed_pos_detail: newData.installed_pos_detail,
          occurFrom : newData.occurFrom === 1 ? formatMessage({id:'occurFrom_Backend'}): formatMessage({id:'occurFrom_Sensor'}),
        };

        // console.log(emergency);
        setEmergencyInfo(emergency)
      }

    });
  }


  useEffect( () => {
    loadData(match.params.eventId);
  }, []);


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { emergencyInfo && <FirstAidUpdateForm emergencyInfo={emergencyInfo} history={history} /> }
      </div>
    </div>
  );
};


FirstAidUpdate.propTypes = {
  history: PropTypes.object
};

export default withRouter(FirstAidUpdate);


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));
